/** Загрузка файла в S3 по presigned PUT с прогрессом (fetch прогресс отправки не отдаёт). */
export function uploadFile(url: string, file: File, onProgress: (fraction: number) => void): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('PUT', url)
    xhr.setRequestHeader('Content-Type', file.type || 'application/octet-stream')
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) onProgress(e.loaded / e.total)
    }
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        onProgress(1)
        resolve()
      } else {
        reject(new Error(`Хранилище ответило ${xhr.status}`))
      }
    }
    xhr.onerror = () => reject(new Error('Не удалось загрузить файл: нет связи с хранилищем'))
    xhr.onabort = () => reject(new Error('Загрузка отменена'))
    xhr.send(file)
  })
}

export const MAX_ATTACHMENT_SIZE = 25 * 1024 * 1024
export const MAX_ATTACHMENTS = 10

/** Мегабайты вложения по уровню сервера (бусты); с «Кличат Плюс» — 500 МБ везде. */
const GUILD_UPLOAD_MB = [25, 50, 100, 500]

/** Потолок размера файла: лучшее из личной подписки и уровня сервера. Тот же расчёт на бэкенде (internal/billing). */
export function attachmentLimit(plus: boolean, guildTier = 0): number {
  const guild = GUILD_UPLOAD_MB[Math.min(Math.max(guildTier, 0), 3)] ?? 25
  return Math.max(plus ? 500 : 25, guild) * 1024 * 1024
}

/** Длина сообщения: 2000, с «Кличат Плюс» — 4000. */
export function messageLimit(plus: boolean): number {
  return plus ? 4000 : 2000
}

export function formatSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} Б`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(bytes < 10 * 1024 ? 1 : 0)} КБ`
  return `${(bytes / (1024 * 1024)).toFixed(1)} МБ`
}
